<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon class="m-2" icon="edit-outline" *ngIf="action === 'edit'"></nb-icon>
        <nb-icon class="m-2" icon="plus-outline" *ngIf="action !== 'edit'"></nb-icon>
        <div *ngIf="action === 'edit'" i18n>Editing Robot: {{ robot.id }}</div>
        <div *ngIf="action === 'clone'" i18n>Cloning Robot: {{ robot.id }}</div>
        <div *ngIf="action === 'create'" i18n>Creating Robot</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 750px">
    <strong class="text-uppercase" i18n>Robot Details</strong>
    <hr />
    <form #robotForm="ngForm">
      <div class="row">
        <div class="col-4" style="padding-top: 10px">
          <label i18n>Robot ID<span style="color: red">*</span>:</label>
        </div>
        <div class="col-8">
          <input
            id="id"
            name="id"
            #name="ngModel"
            [(ngModel)]="robot.id"
            nbInput
            class="form-control"
            style="width: 100%"
            [disabled]="isEdit"
            required
            appValidRegex="^[A-Z0-9]+$"
          />
          <div *ngIf="(name?.touched || name?.dirty) && name?.errors?.required">
            <span class="error" i18n>Robot ID is a required field</span>
          </div>
          <div *ngIf="(name?.touched || name?.dirty) && name?.errors?.validRegex">
            <span class="error" i18n>Only uppercase letters and numbers are allowed.</span>
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-4" style="padding-top: 10px">
          <label i18n>Robot Name<span style="color: red">*</span>:</label>
        </div>
        <div class="col-8">
          <input
            id="name"
            name="name"
            #name="ngModel"
            [(ngModel)]="robot.name"
            nbInput
            class="form-control"
            style="width: 100%"
            required
          />
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-4" style="padding-top: 10px">
          <label i18n>SKU<span style="color: red">*</span>:</label>
        </div>
        <div class="col-8">
          <input
            id="sku"
            name="sku"
            #name="ngModel"
            [(ngModel)]="robot.sku"
            nbInput
            class="form-control"
            style="width: 100%"
            required
          />
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-4" style="padding-top: 10px">
          <label i18n>Serial No. :</label>
        </div>
        <div class="col-8">
          <input
            id="serial_number"
            name="serial_number"
            #name="ngModel"
            [(ngModel)]="robot.serial_number"
            nbInput
            class="form-control"
            style="width: 100%"
          />
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-4" style="padding-top: 10px">
          <label i18n>Timezone<span style="color: red">*</span>:</label>
        </div>
        <div class="col-8">
          <nb-select
            id="timezone"
            name="timezone"
            #name="ngModel"
            [(ngModel)]="robot.timezone"
            class="custom small"
            style="width: 100%"
            required
          >
            <nb-option *ngFor="let option of timezones" [value]="option">{{ option }}</nb-option>
          </nb-select>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-4" style="padding-top: 10px">
          <label i18n>Registration Date<span style="color: red">*</span>:</label>
        </div>
        <div class="col-8">
          <div class="picker-row">
            <input
              id="reg"
              name="reg"
              #name="ngModel"
              nbInput
              [(ngModel)]="dateForDatepickerStart"
              required
              [owlDateTime]="regdatePicker"
              [owlDateTimeTrigger]="regdatePicker"
              placeholder="Choose Registration Date"
              i18n-placeholder
            />
            <owl-date-time #regdatePicker></owl-date-time>
          </div>
        </div>
      </div>
      <br />
    </form>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button
        nbButton
        class="ml-3"
        status="success"
        (click)="save()"
        style="margin: 5px"
        [disabled]="robotForm.valid ? null : ''"
        i18n
      >
        Save
      </button>
    </div>
  </nb-card-footer>
</nb-card>
